import type { TGeneral } from '~/src/types/common'
import {
  cellObjectTextBold,
  cellObjectNumber,
  cellObjectText,
} from './download-xlsx-config'
import {
  cellStylesLineBottom,
  cellStylesNormal,
} from '~/src/constants/download-xlsx-config'

export function getHeadersValuesExcel({ hasPrice, hasPayable }: TGeneral) {
  const showPrice = hasPrice
    ? [
        cellObjectTextBold('Price Low', cellStylesLineBottom),
        cellObjectTextBold('Price High', cellStylesLineBottom),
        cellObjectTextBold('Price Mid', cellStylesLineBottom),
      ]
    : []
  const showPayable = hasPayable
    ? [
        cellObjectTextBold('Payable Low', cellStylesLineBottom),
        cellObjectTextBold('Payable High', cellStylesLineBottom),
        cellObjectTextBold('Payable Mid', cellStylesLineBottom),
      ]
    : []

  return [...showPrice, ...showPayable]
}

export function getHeadersValuesByAllPrices({
  hasPrice,
  hasPayable,
}: TGeneral) {
  const showPrice = hasPrice ? ['Price Low', 'Price High', 'Price Mid'] : []
  const showPayable = hasPayable
    ? ['Payable Low', 'Payable High', 'Payable Mid']
    : []

  return [...showPrice, ...showPayable]
}

export function getHeaderByPropertyExcel(hasValue: boolean, key: string) {
  return hasValue ? [cellObjectTextBold(key, cellStylesLineBottom)] : []
}

export function getHeaderByPropertyAllPrices(hasValue: boolean, key: string) {
  return hasValue ? [key] : []
}

export function getRowsValuesExcel({
  row,
  format,
  hasPrice,
  hasPayable,
}: TGeneral) {
  const priceValues = hasPrice
    ? [
        cellObjectNumber(row.priceLow, format, cellStylesNormal),
        cellObjectNumber(row.priceHigh, format, cellStylesNormal),
        cellObjectNumber(row.priceMid, format, cellStylesNormal),
      ]
    : []
  const payableValues = hasPayable
    ? [
        cellObjectNumber(row.payableLow, format, cellStylesNormal),
        cellObjectNumber(row.payableHigh, format, cellStylesNormal),
        cellObjectNumber(row.payableMid, format, cellStylesNormal),
      ]
    : []

  return [...priceValues, ...payableValues]
}

export function getValueByPropertyExcel(
  row: TGeneral,
  key: string,
  hasValue: boolean,
) {
  return hasValue ? [cellObjectText(row[key], cellStylesNormal)] : []
}

export function getValueBySustainableGradeExcel(
  row: TGeneral,
  hasValue: boolean,
) {
  const value = row.sustainableGrade ? 'Sustainable grade' : ''
  return hasValue ? [cellObjectText(value, cellStylesNormal)] : []
}

export function getConfigValuesExcel({ hasPrice, hasPayable }: TGeneral) {
  const showPrice = hasPrice ? [{ wpx: 90 }, { wpx: 90 }, { wpx: 90 }] : []
  const showPayable = hasPayable
    ? [{ wpx: 100 }, { wpx: 100 }, { wpx: 100 }]
    : []

  return [...showPrice, ...showPayable]
}

export function getConfigByPropertyExcel(hasValue: boolean, length: number) {
  return hasValue ? [{ wpx: length }] : []
}
